<script setup lang="ts">
/**
 * UI-kit component
 * Category: Headers
 * Name: HeaderLinkListGroup
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=4989-790
 *
 * One block of a header menu: a plain-text Title/L heading (never a link) above
 * columns of links, plus an optional See-all CTA (#cta slot) that belongs to the
 * block and renders beneath ALL columns. Columns sit in a row on desktop
 * (gap space/16, never wrapping) and stack full-width inside the tablet/mobile
 * sheet. Every menu block is a group, even with a single column.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui.
 */
// types
import type { HeaderLinkListGroupProps } from '../types/interfaces'

defineOptions({
  name: 'HeaderLinkListGroup',
})

defineProps<HeaderLinkListGroupProps>()
</script>

<template>
  <div class="header-link-list-group">
    <p class="header-link-list-group__title btly-text-title-l">{{ title }}</p>
    <div class="header-link-list-group__list-row">
      <div class="header-link-list-group__columns">
        <slot />
      </div>
      <div
        v-if="$slots.cta"
        class="header-link-list-group__cta"
      >
        <slot name="cta" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_header-link-list-group.scss" />
